module.exports = __webpack_public_path__ + "static/media/01.99492839.jpg";